import React from 'react'
import { useForm } from 'react-hook-form'
import { useMutation } from '@apollo/client'

import ButtonBase from '../../../components/partials/button'
import BaseDialog from '../../../components/dialog'
import iconTimes from '../../../assets/images/icon-times.svg'
import { customStyles } from '../../../constants/customStyles'
import { notify } from '../../../components/toastify'
import { MESSAGES, STATUS } from '../../../constants/messages'
import { useSession } from '../../../helpers/checkSession'
import { GROUP_PRINCIPAL_ACCOUNT_TO_PRINCIPAL_ACCOUNT } from '../../../queries/adminPortal'

interface PropsAction {
  modalIsOpen?: boolean
  hiddenBlock?: string
  handleCloseDialog?: (val: boolean) => void
  setIsDisable?: (val: boolean) => void
  isValueInputPAccountSelectedFrom?: {
    idPrincipalAccountFrom: string
    namePrincipalAccountFrom: string
  }
  isValueInputPAccountSelectedTo?: { idPrincipalAccountTo: string; namePrincipalAccountTo: string }
  handleSubmitPrincipal?: () => void
}

const GroupPAccountToPAccount: React.FunctionComponent<PropsAction> = ({
  modalIsOpen,
  handleCloseDialog = () => null,
  setIsDisable = () => false,
  isValueInputPAccountSelectedFrom = { idPrincipalAccountFrom: '', namePrincipalAccountFrom: '' },
  isValueInputPAccountSelectedTo = { idPrincipalAccountTo: '', namePrincipalAccountTo: '' },
  handleSubmitPrincipal = () => null,
}) => {
  const { handleSubmit, reset } = useForm<PropsAction>()
  const { handleErrorSession } = useSession()
  const [GroupPrincipalAccountToPrincipalAccount] = useMutation(
    GROUP_PRINCIPAL_ACCOUNT_TO_PRINCIPAL_ACCOUNT,
  )

  const onSubmit = handleSubmit(async () => {
    const variables = {
      principalAccountIdFrom: isValueInputPAccountSelectedFrom.idPrincipalAccountFrom,
      principalAccountIdTo: isValueInputPAccountSelectedTo.idPrincipalAccountTo,
    }
    try {
      const dataRes = await GroupPrincipalAccountToPrincipalAccount({ variables: variables })
      if (
        dataRes &&
        isValueInputPAccountSelectedFrom.idPrincipalAccountFrom ===
          isValueInputPAccountSelectedTo.idPrincipalAccountTo
      ) {
        notify(MESSAGES.ERROR.E_DUPLICATED_P_ACCOUNT, STATUS.ERROR)
        handleCloseDialog(false)
      } else if (dataRes) {
        notify(MESSAGES.SUCCESS.S_CREATED_GROUP_PACC_TO_PACC, STATUS.SUCCESS)
        handleCloseDialog(false)
        reset()
      }
      setIsDisable(true)
      handleSubmitPrincipal()
    } catch (error) {
      handleErrorSession(error, MESSAGES.ERROR.E_DUPLICATED_P_ACCOUNT)
    }
  })

  const handleGroup = async () => {
    await onSubmit()
  }

  const handleCloseAddPAccDialog = () => {
    handleCloseDialog(false)
    reset()
  }

  return (
    <BaseDialog modalIsOpen={modalIsOpen} customStyles={customStyles}>
      <div className="w-[378px] p-1">
        <div className="absolute right-4 top-4">
          <img
            src={iconTimes}
            alt="close"
            className="cursor-pointer"
            onClick={handleCloseAddPAccDialog}
          />
        </div>
        <p className="text-center text-headline5A mb-2 ml-4">Group Principal Account</p>
        <p className="text-center text-body1 mb-2 pt-2">
          Do you want to group
          <span className="font-semibold">
            {' '}
            {isValueInputPAccountSelectedFrom.namePrincipalAccountFrom}{' '}
          </span>
          to
          <span className="font-semibold">
            {' '}
            {isValueInputPAccountSelectedTo.namePrincipalAccountTo}
          </span>
          ?
        </p>
        <p className="text-center text-body2 mb-2">
          Please note that the
          <span className="font-semibold">
            {' '}
            {isValueInputPAccountSelectedFrom.namePrincipalAccountFrom}{' '}
          </span>
          will be deleted, and its Principals will be then attached to
          <span className="font-semibold">
            {' '}
            {isValueInputPAccountSelectedTo.namePrincipalAccountTo}{' '}
          </span>
        </p>
        <div className="flex w-[372px]">
          <ButtonBase
            type="submit"
            className="w-[180px] mt-4 bg-primary-1 min-w-min text-center"
            onClick={handleGroup}
            bgDisabled="bg-primary-shade3"
          >
            Group
          </ButtonBase>
          <ButtonBase
            type="submit"
            className="w-[180px] mt-4 ml-3 justify-around border-2 border-primary-1 text-primary-1 bg-neutral-8 hover:bg-primary-shade4"
            onClick={handleCloseAddPAccDialog}
            bgDisabled="bg-primary-shade3"
          >
            Cancel
          </ButtonBase>
        </div>
      </div>
    </BaseDialog>
  )
}

export default GroupPAccountToPAccount
